// 设备相关
import { shareGetDeviceType } from '@/api/modules/public.js'

import matchDeviceType from '@/utils/matchDeviceType'

const actions = {
  getDeviceType ({ dispatch }, { type }) {
    switch (type) {
      case 'sensor':
        return dispatch('getSensorType')
      case 'gateway':
        return dispatch('getGatewayType')
      case 'display':
        return dispatch('getDisplayType')
      case 'relay':
        return dispatch('getRelayType')
      case 'gas':
        return dispatch('getGasType')
      case 'magnetism':
        return dispatch('getmagnetismType')
    }
  },
  getSensorType ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.sensorType.length) {
        let ret = []
        import('@/utils/dict/sensor').then(({ sensorType }) => {
          shareGetDeviceType('sensor').then(({ result }) => {
            ret = matchDeviceType(result, sensorType)
            commit('SET_SENSOR_TYPE', ret)
            resolve(ret)
          })
        })
      } else {
        resolve(state.sensorType)
      }
    })
  },
  getGatewayType ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.gatewayType.length) {
        let ret = []
        import('@/utils/convert').then(({ gatewayType }) => {
          shareGetDeviceType('gateway').then(({ result }) => {
            ret = matchDeviceType(result, gatewayType)
            commit('SET_GATEWAY_TYPE', ret)
            resolve(ret)
          })
        })
      } else {
        resolve(state.gatewayType)
      }
    })
  },
  getDisplayType ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.displayType.length) {
        let ret = []
        import('@/utils/convert').then(({ displayscreenType }) => {
          shareGetDeviceType('display').then(({ result }) => {
            ret = matchDeviceType(result, displayscreenType)
            commit('SET_DISPLAY_TYPE', ret)
            resolve(ret)
          })
        })
      } else {
        resolve(state.displayType)
      }
    })
  },
  getRelayType ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.relayType.length) {
        let ret = []
        import('@/utils/convert').then(({ relayType }) => {
          shareGetDeviceType('relay').then(({ result }) => {
            ret = matchDeviceType(result, relayType)
            commit('SET_RELAY_TYPE', ret)
            resolve(ret)
          })
        })
      } else {
        resolve(state.relayType)
      }
    })
  },
  getGasType ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.gasType.length) {
        let ret = []
        import('@/utils/convert').then(({ gasType }) => {
          shareGetDeviceType('gas').then(({ result }) => {
            ret = matchDeviceType(result, gasType)
            commit('SET_GAS_TYPE', ret)
            resolve(ret)
          })
        })
      } else {
        resolve(state.gasType)
      }
    })
  },
  getMagnetismType ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.magnetismType.length) {
        let ret = []
        import('@/utils/convert').then(({ magnetismType }) => {
          shareGetDeviceType('magnetism').then(({ result }) => {
            ret = matchDeviceType(result, magnetismType)
            commit('SET_magnetism_TYPE', ret)
            resolve(ret)
          })
        })
      } else {
        resolve(state.magnetismType)
      }
    })
  },
}
const mutations = {
  SET_SENSOR_TYPE: (state, sensorType) => {
    state.sensorType = sensorType
  },
  SET_GATEWAY_TYPE: (state, gatewayType) => {
    state.gatewayType = gatewayType
  },
  SET_DISPLAY_TYPE: (state, displayType) => {
    state.displayType = displayType
  },
  SET_RELAY_TYPE: (state, relayType) => {
    state.relayType = relayType
  },
  SET_GAS_TYPE: (state, gasType) => {
    state.gasType = gasType
  },
  SET_magnetism_TYPE: (state, magnetismType) => {
    state.magnetismType = magnetismType
  },
}
const state = {
  sensorType: [],
  gatewayType: [],

  displayType: [],
  relayType: [],
  gasType: [],
  magnetismType: []
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
